<template>
<div style="text-align: center; margin-top: 20px;">
  <mdl-spinner single-color></mdl-spinner>
</div>
</template>
<script>
import { MdlSpinner } from 'vue-mdl'

export default {
  components: {
    MdlSpinner
  }
}
</script>



// WEBPACK FOOTER //
// MySpinner.vue?7ec5661b